import 'reflect-metadata';
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Transform, Type } from 'class-transformer';
import { IsArray, IsEnum, IsInt, IsOptional, IsString, Max, Min } from 'class-validator';

export enum Order {
    ASC = 'ASC',
    DESC = 'DESC'
}

export class PageOptionsDto {
    @IsEnum(Order)
    @IsOptional()
    order?: Order = Order.ASC;

    @Type(() => Number)
    @IsInt()
    @Min(1)
    @IsOptional()
    page?: number = 1;

    @Type(() => Number)
    @IsInt()
    @Min(1)
    @Max(200)
    @IsOptional()
    take?: number = 10;

    @IsString()
    @IsOptional()
    sortField?: string = 'createdAt';

    @Transform((filters) => JSON.parse(filters.value))
    @Type(() => Array<PageFilterOptionsDto>)
    @IsArray()
    @IsOptional()
    filters?: PageFilterOptionsDto[] = [];

    get skip(): number {
        return (this.page! - 1) * this.take!;
    }
}

export class PageFilterOptionsDto {
    @IsString()
    field!: string;

    @IsString()
    matchMode!: FilterMatchMode;

    @Transform((values) => JSON.parse(values.value))
    @IsString()
    value!: string | string[];
}

export enum FilterMatchMode {
    STARTS_WITH = 'startsWith',
    CONTAINS = 'contains',
    NOT_CONTAINS = 'notContains',
    ENDS_WITH = 'endsWith',
    EQUALS = 'equals',
    NOT_EQUALS = 'notEquals',
    IN = 'in',
    LESS_THAN = 'lt',
    LESS_THAN_OR_EQUAL_TO = 'lte',
    GREATER_THAN = 'gt',
    GREATER_THAN_OR_EQUAL_TO = 'gte',
    BETWEEN = 'between',
    IS = 'is',
    IS_NOT = 'isNot',
    BOOL_IS = 'boolIs',
    BEFORE = 'before',
    AFTER = 'after',
    DATE_IS = 'dateIs',
    DATE_IS_NOT = 'dateIsNot',
    DATE_BEFORE = 'dateBefore',
    DATE_AFTER = 'dateAfter'
}
